import { FC } from 'react';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { UserRoles } from '@dynamika-shared/types/auth';
import { useAuthSlice } from '@restore/auth/auth.slice';

type WithAuthorizationProps = {
  allowedRoles: UserRoles[];
  children: React.ReactNode;
};

export const WithUserRolesHoc: FC<WithAuthorizationProps> = ({
  allowedRoles,
  children,
}) => {
  const userData = useAuthSlice(s => s.data);

  if (!userData?.selectedRole || !allowedRoles?.length) {
    return null;
  }

  if (allowedRoles.includes(userData.selectedRole)) {
    return <>{children}</>;
  } else {
    return <Navigate to='/404' />;
  }
};
